import { DateTime } from 'luxon';

import AdvancedReport from '@/common/models/reports/AdvancedReport';

import * as types from './mutation-types';

const actions = {
  createNewAdvancedReportDefinition(
    { commit },
    advancedReport = new AdvancedReport(-1, '', {
      breakdown: 'CUMULATIVE',
      format: 'csv',
      dates: {
        reportForMonth: '',
        reportForYear: '',
        mode: 'RELATIVE',
        date_range: 'PREVIOUS_30_DAYS',
      },
      defaultReportOutputFormat: 'csv',
      timezone: DateTime.local().zone.name,
    }),
  ) {
    commit(types.CREATE_ADVANCEDREPORT_DEFINITION, advancedReport);
    return advancedReport;
  },
};

export default actions;
